import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const iframe: AdminBlockTypeAttribute = {
  label: 'HTML contains responsive iframe',
  key: 'iframe',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default iframe;
